import { Component, Input, forwardRef, OnInit, OnChanges } from '@angular/core';
import * as uuid from 'uuid';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { SeriesCountFieldModel } from '../../../PageBuilder/models/series-count-field.model';
import { ChartDisplayElementModel } from '../../models/chart-display-element.model';
import { ReportSeriesModel } from '../../models/report-series.model';
import { ReportBlockTypeEnum } from '../../enums/report-block-type.enum';

@Component({
    selector: 'agpr-series-count-field',
    templateUrl: './series-count-field.component.html',
    styleUrls: ['./series-count-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => SeriresCountFieldComponent)
        }
    ],
    standalone: false
})
export class SeriresCountFieldComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {
    @Input() declare field: SeriesCountFieldModel;

    seriesCount: DropdownOptionModel = null;

    constructor(public localizationService: LocalizationService) {
        super();
    }

    ngOnInit(): void {
        this.setSeriesCount();
        this.changes.emit(this.value);
    }

    ngOnChanges() {
        if (!this.value) {
            const displayElement = this.block?.displayElement as ChartDisplayElementModel;
            if (displayElement.seriesCount) {
                this.onDropdownChanged(displayElement.seriesCount);
            } else if (this.field?.defaultValue) {
                this.onDropdownChanged(this.field?.defaultValue);
            }
        }
    }

    onDropdownChanged(value: any) {
        this.value = value;
        this.setSeriesCount();
        this.changes.emit(this.value);
    }

    setSeriesCount(): void {
        if (this.field.options && this.field.options.length > 0) {
            this.seriesCount = this.field.options.find(option => option.value === this.value);
        }
        if (this.seriesCount) {
            const displayElement = this.block?.displayElement as ChartDisplayElementModel;
            const oldSeries = displayElement.series.map(s => s.partialClone());

            const series = new ReportSeriesModel(null, this.block?.type?.key as ReportBlockTypeEnum, this.field.type);
            if (oldSeries[0]) {
                series.dateRange = oldSeries[0].dateRange;
            }
            displayElement.series = [];
            for (let i = 0; i < this.seriesCount.value; i++) {
                let newSeries = series.clone();
                if (oldSeries && oldSeries[i]) {
                    newSeries = oldSeries[i];
                }
                newSeries.seriesUniqueUuid = uuid.v4();
                newSeries.dataIndex = i;
                newSeries.label = `${this.localizationService.transform(`Reports.series.type.${this.field.type}`)} ${i + 1}`;
                displayElement.series.push(newSeries);
            }
        }
    }
}
